import { UserManager, WebStorageStateStore, Log } from 'oidc-client-ts'

// Route oidc-client-ts internal logging to the console at WARN so silent-renew /
// token-exchange failures surface, without the verbose per-request INFO noise.
Log.setLogger(console)
Log.setLevel(Log.WARN)

// Production OIDC identifiers for the Authentik tenant. These are PUBLIC values: they ship in
// every client bundle by design (a public PKCE SPA client has no secret). They are kept as
// fallbacks so a build with a missing or empty VITE_OIDC_* env can never white-screen the app
// (an empty client_id makes oidc-client-ts fail to initialise). A build-time env var still
// overrides them for non-production tenants.
const OIDC_ISSUER =
  (import.meta.env['VITE_OIDC_ISSUER'] as string) ||
  'https://sso.terramantle.dev/application/o/terramantle-app/'
const OIDC_CLIENT_ID = (import.meta.env['VITE_OIDC_CLIENT_ID'] as string) || 'Terramantle App'

export const oidcConfig = {
  authority: OIDC_ISSUER,
  client_id: OIDC_CLIENT_ID,
  redirect_uri: window.location.origin + '/callback',
  // A public route (outside AuthGuard): landing on '/' after logout would
  // immediately auto-signinRedirect and, with a surviving SSO session, silently
  // sign the user straight back in. Registered as a logout redirect URI on the
  // Authentik SPA provider.
  post_logout_redirect_uri: window.location.origin + '/signed-out',
  // `terramantle` is the Authentik scope that emits the aud (registry.terramantle.dev)
  // and roles claims. offline_access makes Authentik issue a refresh token.
  scope: 'openid profile email offline_access terramantle',
  response_type: 'code',
  // offline_access (above) makes Authentik issue a refresh token; useRefreshToken
  // makes oidc-client-ts renew via the refresh-token grant instead of a hidden
  // iframe. automaticSilentRenew renews proactively ~60s before access-token
  // expiry so the user is never bounced to the login page mid-session.
  automaticSilentRenew: true,
  useRefreshToken: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}

export const userManager = new UserManager(oidcConfig)
